import React from 'react';
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import ReactPlayer from 'react-player';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Divider from "@mui/material/Divider";
import { useTheme } from '@mui/material/styles';
import SchoolIcon from '@mui/icons-material/School';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import LearnForex from "components/LearnForex"; 

function Tutorials() {
  const theme = useTheme();
  const iconColor = theme.palette.mode === 'dark' ? theme.palette.grey[200] : theme.palette.grey[600];

  const tooltipContent = `Tutorial Videos:

• Learn how to use FX Bullsheet
• Step-by-step guides for features
• Tips for getting the most from the platform`;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <MDBox p={3}>
                {/* Header */}
                <MDBox display="flex" justifyContent="space-between" alignItems="center">
                  <MDBox display="flex" alignItems="center">
                    <MDBox
                      variant="gradient"
                      bgColor="light"
                      color="dark"
                      coloredShadow="light"
                      borderRadius="xl"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      width="4rem"
                      height="4rem"
                      mt={-3}
                    >
                      <SchoolIcon fontSize="medium" color="inherit" />
                    </MDBox>
                    <MDBox ml={2}>
                      <MDTypography variant="h6" fontWeight="medium">
                        FX Bullsheet Tutorials
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  <Tooltip 
                    title={tooltipContent}
                    placement="bottom-end"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: theme.palette.background.paper,
                          color: iconColor,
                          border: `1px solid ${theme.palette.divider}`,
                          p: 1.5,
                          maxWidth: '250px',
                          fontSize: '0.75rem',
                          lineHeight: 1.5,
                        }
                      }
                    }}
                  >
                    <InfoIcon sx={{ ml: 1, fontSize: '1rem', color: iconColor, cursor: 'help' }} />
                  </Tooltip>
                </MDBox>

                <Divider sx={{ my: 3 }} />

                {/* Video Content */}
                <Grid container spacing={3}>
                  <Grid item xs={12} lg={6}>
                    <MDBox mb={3}>
                      <MDTypography variant="h6" mb={2}>Getting Started with FX Bullsheet</MDTypography>
                      <MDBox sx={{ aspectRatio: '16/9' }}>
                        <ReactPlayer
                          url="https://www.youtube.com/watch?v=oR5Dj3hevE0"
                          width="100%"
                          height="100%"
                          controls={true}
                        />
                      </MDBox>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <MDBox mb={3}>
                      <MDTypography variant="h6" mb={2}>Backtesting Tutorial</MDTypography>
                      <MDBox sx={{ aspectRatio: '16/9' }}>
                        <ReactPlayer
                          url="https://www.youtube.com/watch?v=5llo_dRyRSE&t=94s"
                          width="100%"
                          height="100%"
                          controls={true}
                        />
                      </MDBox>
                    </MDBox>
                  </Grid>
                  </Grid>

<Divider sx={{ my: 3 }} />

{/* Learn Forex Component */}
<MDBox>
  <MDTypography variant="h6" mb={2}>Learn Forex Trading</MDTypography>
  <LearnForex />
</MDBox>
</MDBox>
</Card>
</Grid>
</Grid>
</MDBox>
<Footer />
</DashboardLayout>
);
}

export default Tutorials;